export default "__VITE_ASSET__CY9RdYRr__"